<template>
    <div id="entire_bussearch_component">
        <div class="header">
            <h1>All <strong>{{ $store.state.Search.search_results.length }}</strong> bus ticket found</h1>
        </div>
        
        <div class="no_tickets_status_container" v-if="$store.state.Search.search_results.length <= 0" style="display: flex; flex-direction: column; margin-top: 1.5em">
            <img src="../../../assets/no.png" alt="" style="margin-bottom: 0.5em">
            <p>No tickets related to your search</p>
        </div>

        <div class="tickets_found_comp col-mob-11">
            <div class="ticket" v-for="ticket in $store.state.Search.search_results" :key="ticket">
                <div class="place_time_details">
                    <div class="time">
                        <h3>{{ formatRemoveSeconds(ticket.starttime) }} <span>Hrs</span></h3>
                        <p>2 hours</p>
                        <h3>3:30 <span>PM</span></h3>
                    </div>
                    <div class="show_route">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="127" viewBox="0 0 32 127">
                            <g id="Ellipse_35" data-name="Ellipse 35" transform="translate(1)" fill="none" stroke="#487fff" stroke-width="3">
                                <circle cx="15" cy="15" r="15" stroke="none"/>
                                <circle cx="15" cy="15" r="13.5" fill="none"/>
                            </g>
                            <g id="Ellipse_36" data-name="Ellipse 36" transform="translate(7 6)" fill="none" stroke="#487fff" stroke-width="3">
                                <circle cx="9" cy="9" r="9" stroke="none"/>
                                <circle cx="9" cy="9" r="7.5" fill="none"/>
                            </g>
                            <g id="map-pin-line" transform="translate(0 95)">
                                <path id="Path_79" data-name="Path 79" d="M0,0H32V32H0Z" fill="none"/>
                                <path id="Path_80" data-name="Path 80" d="M16,27.859l7.15-6.773a9.224,9.224,0,0,0,0-13.544,10.514,10.514,0,0,0-14.3,0,9.224,9.224,0,0,0,0,13.544Zm0,3.869L6.808,23.021a11.859,11.859,0,0,1,0-17.414,13.518,13.518,0,0,1,18.385,0,11.859,11.859,0,0,1,0,17.414ZM16,17.05a2.816,2.816,0,0,0,2.889-2.736,2.893,2.893,0,0,0-5.778,0A2.816,2.816,0,0,0,16,17.05Zm0,2.736a5.631,5.631,0,0,1-5.778-5.473A5.631,5.631,0,0,1,16,8.841a5.631,5.631,0,0,1,5.778,5.473A5.631,5.631,0,0,1,16,19.786Z" transform="translate(0 0)" fill="#487fff"/>
                            </g>
                            <line id="Line_22" data-name="Line 22" y2="70" transform="translate(15.5 28.5)" fill="none" stroke="#487fff" stroke-width="3" stroke-dasharray="10"/>
                        </svg>
                    </div>
                    <div class="places">
                        <h4>{{ ticket.source }}</h4>
                        <p>{{ ticket.busplatenumber }}</p>
                        <h4>{{ ticket.destination }}</h4>
                    </div>
                </div>
                <div class="bus_company">
                    <img src="../../../assets/comp4.png" alt="bus company">
                </div>
                <div class="book_now">
                    <div class="more">
                        <svg id="more-2-fill" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                            <path id="Path_69" data-name="Path 69" d="M0,0H24V24H0Z" fill="none"/>
                            <path id="Path_70" data-name="Path 70" d="M12,3a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,3Zm0,14a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,17Zm0-7a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,10Z" fill="#1d2329"/>
                        </svg>
                    </div>
                    <div class="book_now">
                        <div class="book_btn">
                            <!-- <div class="map">
                                <svg id="road-map-line" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                    <path id="Path_152" data-name="Path 152" d="M0,0H20V20H0Z" fill="none"/>
                                    <path id="Path_153" data-name="Path 153" d="M3.6,5.163V15.545l4.052-1.757,4.8,2.429L16.4,14.5V4.122l1.042-.452a.4.4,0,0,1,.378.034.406.406,0,0,1,.18.338V15.571L12.4,18,7.6,15.571,2.558,17.758a.4.4,0,0,1-.378-.034A.406.406,0,0,1,2,17.386V5.857Zm9.794,4.129L10,12.726,6.606,9.292a4.9,4.9,0,0,1,0-6.869,4.76,4.76,0,0,1,6.788,0,4.9,4.9,0,0,1,0,6.869ZM10,10.437l2.262-2.29a3.265,3.265,0,0,0,0-4.58,3.173,3.173,0,0,0-4.526,0,3.265,3.265,0,0,0,0,4.58Z" transform="translate(0 0)" fill="#2c343a"/>
                                </svg>
                                <p>map</p>
                            </div> -->
                            <div class="book" @click="$store.commit('Booking/setTicket', ticket)">
                                <router-link class="link" :to="{ path: '/search', query: { ticket: ticket.scheduleid }}">Book</router-link>
                                <svg id="suitcase-3-line" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 22 22">
                                    <path id="Path_158" data-name="Path 158" d="M0,0H22V22H0Z" fill="none"/>
                                    <path id="Path_159" data-name="Path 159" d="M13.667,1a.9.9,0,0,1,.889.9V6.429h.889v-.9h1.778v.9h.889a.9.9,0,0,1,.889.9V18.19a.9.9,0,0,1-.889.9h-.889V20H15.444v-.9H6.556V20H4.778v-.9H3.889A.9.9,0,0,1,3,18.19V7.333a.9.9,0,0,1,.889-.9h.889v-.9H6.556v.9h.889V1.9A.9.9,0,0,1,8.333,1Zm3.556,7.238H4.778v9.048H17.222Zm-8.889.9v7.238H6.556V9.143Zm3.556,0v7.238H10.111V9.143Zm3.556,0v7.238H13.667V9.143ZM12.778,2.81H9.222V6.429h3.556Z" fill="#fff"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="price">
                        <div class="price_money">
                            <p>{{ ticket.price }} <span>Rwf</span></p>
                        </div>
                        <!-- <div class="buy">
                            <svg id="exchange-dollar-line" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 28 28">
                                <path id="Path_65" data-name="Path 65" d="M0,0H28V28H0Z" fill="none"/>
                                <path id="Path_66" data-name="Path 66" d="M22.785,17.724A9.649,9.649,0,0,0,20.321,6.812,9.476,9.476,0,0,0,9.271,5.664L8.089,3.579a11.832,11.832,0,0,1,11.867.029,12.046,12.046,0,0,1,4.9,15.324l1.6.929L21.5,22.517l-.2-5.657,1.484.863ZM5.215,10.276A9.649,9.649,0,0,0,7.68,21.188a9.476,9.476,0,0,0,11.05,1.149l1.182,2.084a11.832,11.832,0,0,1-11.867-.029A12.046,12.046,0,0,1,3.14,9.068l-1.6-.928L6.5,5.484l.2,5.657-1.484-.863ZM9.831,16.4h6.552a.6.6,0,0,0,0-1.2H11.618a3,3,0,0,1,0-6h1.191V8h2.382V9.2h2.978v2.4H11.618a.6.6,0,0,0,0,1.2h4.765a3,3,0,0,1,0,6H15.191V20H12.809V18.8H9.831Z" transform="translate(0 0)" fill="#c14c70"/>
                            </svg>
                            <p>Buy</p>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>

        <div class="available_routes_on_mobile">
            <div class="tickets_found">
                <div class="ticket" v-for="ticket in $store.state.Search.search_results" :key="ticket">
                    <div class="tickets_container">                    
                        <div class="place_time_details">
                            <div class="time">
                                <h3>{{ formatRemoveSeconds(ticket.starttime) }} <span>Hrs</span></h3>
                                <p>2 hours</p>
                                <h3>3:30 <span>PM</span></h3>
                            </div>
                            <div class="show_route">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="127" viewBox="0 0 32 127">
                                    <g id="Ellipse_35" data-name="Ellipse 35" transform="translate(1)" fill="none" stroke="#487fff" stroke-width="3">
                                        <circle cx="15" cy="15" r="15" stroke="none"/>
                                        <circle cx="15" cy="15" r="13.5" fill="none"/>
                                    </g>
                                    <g id="Ellipse_36" data-name="Ellipse 36" transform="translate(7 6)" fill="none" stroke="#487fff" stroke-width="3">
                                        <circle cx="9" cy="9" r="9" stroke="none"/>
                                        <circle cx="9" cy="9" r="7.5" fill="none"/>
                                    </g>
                                    <g id="map-pin-line" transform="translate(0 95)">
                                        <path id="Path_79" data-name="Path 79" d="M0,0H32V32H0Z" fill="none"/>
                                        <path id="Path_80" data-name="Path 80" d="M16,27.859l7.15-6.773a9.224,9.224,0,0,0,0-13.544,10.514,10.514,0,0,0-14.3,0,9.224,9.224,0,0,0,0,13.544Zm0,3.869L6.808,23.021a11.859,11.859,0,0,1,0-17.414,13.518,13.518,0,0,1,18.385,0,11.859,11.859,0,0,1,0,17.414ZM16,17.05a2.816,2.816,0,0,0,2.889-2.736,2.893,2.893,0,0,0-5.778,0A2.816,2.816,0,0,0,16,17.05Zm0,2.736a5.631,5.631,0,0,1-5.778-5.473A5.631,5.631,0,0,1,16,8.841a5.631,5.631,0,0,1,5.778,5.473A5.631,5.631,0,0,1,16,19.786Z" transform="translate(0 0)" fill="#487fff"/>
                                    </g>
                                    <line id="Line_22" data-name="Line 22" y2="70" transform="translate(15.5 28.5)" fill="none" stroke="#487fff" stroke-width="3" stroke-dasharray="10"/>
                                </svg>
                            </div>
                            <div class="places">
                                <h4>{{ ticket.source }}</h4>
                                <p>{{ ticket.busplatenumber }}</p>
                                <h4>{{ ticket.destination }}</h4>
                            </div>
                        </div>
                        <div class="book_now">
                            <div class="more">
                                <p>{{ ticket.companyname }}</p>
                            </div>
                            <div class="book_now">
                                <div class="book_btn">
                                    <div class="book" @click="$store.commit('Booking/setTicket', ticket)">
                                        <svg id="suitcase-3-line" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 22 22">
                                            <path id="Path_158" data-name="Path 158" d="M0,0H22V22H0Z" fill="none"/>
                                            <path id="Path_159" data-name="Path 159" d="M13.667,1a.9.9,0,0,1,.889.9V6.429h.889v-.9h1.778v.9h.889a.9.9,0,0,1,.889.9V18.19a.9.9,0,0,1-.889.9h-.889V20H15.444v-.9H6.556V20H4.778v-.9H3.889A.9.9,0,0,1,3,18.19V7.333a.9.9,0,0,1,.889-.9h.889v-.9H6.556v.9h.889V1.9A.9.9,0,0,1,8.333,1Zm3.556,7.238H4.778v9.048H17.222Zm-8.889.9v7.238H6.556V9.143Zm3.556,0v7.238H10.111V9.143Zm3.556,0v7.238H13.667V9.143ZM12.778,2.81H9.222V6.429h3.556Z" fill="#fff"/>
                                        </svg>
                                        <router-link class="link" :to="{ path: '/routes', query: { ticket: ticket.scheduleid }}">Book</router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="price">
                                <div class="price_money">
                                    <p>{{ ticket.price }} <span>RWF</span></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="more_details_about_ticket">
                        <div class="seats">
                            <p>{{ ticket.sits }} seats left</p>
                        </div>
                        <div class="date">
                            <p>{{ formatDate(ticket.date) }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import formatDateMixin from '../../../mixins/formatDateMixins';
    import formatSeconds from '../../../mixins/formatSeconds';
  
    export default {
        name: 'BusSearch',
        components: {},

        data() {
            return{
            }
        },

        mixins: [formatDateMixin, formatSeconds],
        
    }

</script>

<style lang="scss" scoped>
    #entire_bussearch_component {
        width: 100%;
        height: auto;
        font-family:satoshi, $poppins !important;

        .header {
            height: 8vh;
            width: 100%;
            padding-left: 1.6%;
            position: relative;
            display: flex;
            align-items: center;
            position: sticky;
            top: 0;
            background: $pureWhite;
            z-index: 2;

            h1 {
                font-size: 0.8em;
                color: $mainDark
            }
        }

        .no_tickets_status_container {
            width: 100%;
            height: 20vh;
            display: flex;
            align-items: center;
            justify-content: center;

            p {
                font-size: 0.86em;
                font-family:satoshi, $poppins !important;
                color: $mainDark;
                opacity: 0.6;
            }
        }

        .available_routes_on_mobile {
            display: none;
        }

        .tickets_found_comp {
            width: 100%;
            height: 100vh;
            padding: 0 1.6% 0 1.6%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .ticket {
                width: 49%;
                height: 18vh;
                border-radius: 0.3em;
                background: $unusedticket;
                margin: 0.3em 0;
                padding: 0.5em 1em;
                display: flex;
                flex-wrap: nowrap;

                .place_time_details, .book_now {
                    width: 35%;
                    height: 100%;
                }

                .place_time_details {
                    width: 40% !important;
                    display: flex;

                    .time, .places {
                        width: 50%;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                    }

                    .time {
                        width: 40% !important;
                        text-align: right;

                        h3 {
                            color: $mainDark;
                            font-family:satoshi, $poppins !important;
                            font-size: 0.9em;
                            font-weight: 600;
                            opacity: 0.7;

                            span {
                                font-size: 0.7em !important; 
                                opacity: 0.6;
                            }
                        }

                        p {
                            font-size: 0.67em;
                            font-family:satoshi, $poppins !important;
                            color: $mainDark;
                            opacity: 0.4;
                        }
                    }

                    .places {
                        text-align: left;
                        position: relative;

                        h4 {
                            color: $mainDark;
                            font-family:satoshi, $poppins !important;
                            font-size: 0.8em;
                            font-weight: 600;
                            opacity: 0.65;

                        }

                        p {
                            font-size: 0.67em;
                            font-family:satoshi, $poppins !important;
                            color: $mainDark;
                            opacity: 0.4;
                        }
                    }

                    .show_route {
                        width: 20%;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        svg {
                            width: 64%;
                        }
                    }

                }

                .bus_company {
                    width: 30%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    img {
                        width: 50%;
                    }
                    
                }
                
                .book_now {
                    .more, .book_now, .price {
                        width: 100%;
                        height: 33.333%;

                    }

                    .more {
                        position: relative;

                        svg {
                            position: absolute;
                            top: 15%;
                            right: 0;
                        }
                    }

                    .book_now {
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        .book_btn {
                            // width: 100%;
                            width: 50%;
                            height: 85%;
                            border-radius: 0.3em;
                            background: $mainBlue;
                            display: flex;
                            align-items: center;
                            // justify-content: space-around;
                            justify-content: flex-end;

                            .map {
                                width: 45%;
                                height: 88%;
                                border-radius: 0.3em;
                                background: $pureWhite;
                                display: flex;
                                align-items: center;
                                justify-content: space-evenly;

                                p {
                                    font-size: 0.8em;
                                    font-weight: 500;
                                    color: $mainDark;
                                }
                            }

                            .book {
                                background: transparent;
                                // width: 49%;
                                width: 100%;
                                height: 100%;
                                display: flex;
                                align-items: center;
                                justify-content: space-evenly;

                                a {
                                    font-size: 0.82em;
                                    font-weight: 500;
                                    color: $pureWhite !important;
                                }
                            }
                        }
                    }

                    .price {
                        display: flex;
                        justify-content: space-evenly;
                        align-items: center;

                        .price_money {
                            width: 50%;
                            height: 100%;
                            display: flex;
                            justify-content: flex-end;
                            align-items: center;
                            position: relative;

                            p {
                                font-size: 0.9em;
                                font-weight: 600;
                                opacity: 0.8;
                                position: absolute;
                                right: 0;

                                span {
                                    font-size: 0.8em;
                                    opacity: 0.7;
                                    text-transform: uppercase;
                                }
                            }
                        }

                        .buy {
                            width: 50%;
                            height: 100%;
                            display: flex;
                            justify-content: flex-end;
                            align-items: center;

                            p {
                                font-size: 0.8em;
                                font-weight: 600;
                                opacity: 0.8;
                                margin-left: 0.5em;
                                color: #C14C70;
                            }
                        }
                    }
                }
            }
        }
    }

      @media only screen and (max-width: 600px) { 
        #entire_bussearch_component {
            .header {
                h1 {
                    margin-left: 1em;
                }
            }

            .tickets_found_comp {
                display: none;
            }

            .available_routes_on_mobile {
                width: 100%;
                height: auto;
                display: block;
                margin-bottom: 1em;

                .tickets_found {
                    width: 100%;
                    height: auto;
                    padding: 0 1.6% 0 1.6%;

                    .ticket {
                        width: 100%;
                        height: auto;
                        border-radius: 0.3em;
                        background: $unusedticket;
                        margin: 0.5em 0;
                        padding: 0.5em 1em;

                        .tickets_container {
                            width: 100%;
                            height: 18vh;
                            display: flex;
                            flex-wrap: nowrap;

                            .place_time_details, .book_now {
                                width: 35%;
                                height: 100%;
                            }

                            .place_time_details {
                                width: 70% !important;
                                display: flex;

                                .time, .places {
                                    // width: 50%;
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-around;
                                }

                                .time {
                                    width: 30% !important;
                                    text-align: right;

                                    h3 {
                                        color: $mainDark;
                                        font-family:satoshi, $poppins !important;
                                        font-size: 0.85em;
                                        font-weight: 600;
                                        opacity: 0.7;

                                        span {
                                            font-size: 0.7em !important; 
                                            opacity: 0.6;
                                        }
                                    }

                                    p {
                                        font-size: 0.67em;
                                        font-family:satoshi, $poppins !important;
                                        color: $mainDark;
                                        opacity: 0.4;
                                    }
                                }

                                .places {
                                    width: 50%;
                                    text-align: left;
                                    position: relative;

                                    h4 {
                                        color: $mainDark;
                                        font-family: satoshi, $poppins !important;
                                        font-size: 0.8em;
                                        font-weight: 600;
                                        opacity: 0.65;

                                    }

                                    p {
                                        font-size: 0.67em;
                                        font-family:satoshi, $poppins !important;
                                        color: $mainDark;
                                        opacity: 0.4;
                                    }
                                }

                                .show_route {
                                    width: 20%;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;

                                    svg {
                                        width: 54%;
                                    }
                                }

                            }

                            // .bus_company {
                            //     width: 30%;
                            //     height: 100%;
                            //     display: flex;
                            //     justify-content: center;
                            //     align-items: center;

                            //     img {
                            //         width: 50%;
                            //     }
                                
                            // }
                            
                            .book_now {
                                .more, .book_now, .price {
                                    width: 100%;
                                    height: 33.333%;
                                }

                                .more {
                                    position: relative;
                                    display: flex;
                                    align-items: center;
                                    justify-content: flex-end;

                                    p {
                                        text-align: end;
                                        color: $mainDark;
                                        font-family: satoshi, $poppins !important;
                                        font-size: 0.8em;
                                        font-weight: 600;
                                        opacity: 0.65;
                                    }
                                }

                                .book_now {
                                    display: flex;
                                    justify-content: flex-end;
                                    align-items: center;

                                    .book_btn {
                                        width: 80%;
                                        height: 85%;
                                        border-radius: 0.3em;
                                        background: $mainBlue;
                                        display: flex;
                                        align-items: center;
                                        justify-content: space-around;

                                        // .map {
                                        //     width: 45%;
                                        //     height: 88%;
                                        //     border-radius: 0.3em;
                                        //     background: $pureWhite;
                                        //     display: flex;
                                        //     align-items: center;
                                        //     justify-content: space-evenly;

                                        //     p {
                                        //         font-size: 0.8em;
                                        //         font-weight: 500;
                                        //         color: $mainDark;
                                        //     }
                                        // }

                                        .book {
                                            background: transparent;
                                            width: 100%;
                                            height: 100%;
                                            display: flex;
                                            align-items: center;
                                            justify-content: space-evenly;

                                            a {
                                                font-size: 0.82em;
                                                font-weight: 500;
                                                color: $pureWhite !important;
                                            }
                                        }
                                    }
                                }

                                .price {
                                    display: flex;
                                    justify-content: flex-end;
                                    align-items: center;

                                    .price_money {
                                        width: 50%;
                                        height: 100%;
                                        display: flex;
                                        justify-content: flex-start;
                                        align-items: center;

                                        p {
                                            font-size: 0.8em;
                                            font-weight: 600;
                                            opacity: 0.75;
                                            text-align: end;

                                            span {
                                                font-size: 0.8em;
                                                opacity: 0.7;
                                                text-transform: uppercase;
                                            }
                                        }
                                    }

                                    .buy {
                                        width: 50%;
                                        height: 100%;
                                        display: flex;
                                        justify-content: flex-end;
                                        align-items: center;

                                        p {
                                            font-size: 0.8em;
                                            font-weight: 600;
                                            opacity: 0.8;
                                            margin-left: 0.5em;
                                        }
                                    }
                                }
                            }
                        }

                        .more_details_about_ticket {
                            width: 100%;
                            height: 4vh;
                            margin-top: 0.4em;
                            border-top: 1.8px solid $pureWhite;
                            display: flex;
                            flex-wrap: wrap;

                            .date {
                                width: 50%;
                                height: 100%;

                                p {
                                    text-align: end !important;
                                }
                            }
                            
                            .seats {
                                width: 50%;
                                height: 100%;  
                            }

                            .date, .seats {
                                display: flex;
                                align-items: center;

                                p {
                                    font-size: 0.76em;
                                    font-family:satoshi, $poppins !important;
                                    color: $mainDark;
                                    opacity: 0.6;
                                }
                            }
                        }

                    }
                }
            }
        }
    }
</style>